// Salt Hound Global Animation System

document.addEventListener("DOMContentLoaded", function () {
  const revealElements = document.querySelectorAll(
    ".sh-reveal, .sh-fade-up, .sh-fade-in, .sh-image-reveal"
  );

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (reduceMotion) {
    revealElements.forEach(function (element) {
      element.classList.add("is-visible");
      element.style.transform = "none";
    });
    return;
  }

  if ("IntersectionObserver" in window) {
    const revealObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: "0px 0px -8% 0px"
      }
    );

    revealElements.forEach(function (element) {
      revealObserver.observe(element);
    });
  } else {
    revealElements.forEach(function (element) {
      element.classList.add("is-visible");
    });
  }

  const parallaxElements = document.querySelectorAll(".sh-parallax");
  if (!parallaxElements.length) return;

  function updateParallax() {
    parallaxElements.forEach(function (element) {
      const rect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      if (rect.top < windowHeight && rect.bottom > 0) {
        const progress = (windowHeight - rect.top) / (windowHeight + rect.height);
        const movement = (progress - 0.5) * 40;
        element.style.transform = `translateY(${movement}px)`;
      }
    });

    window.requestAnimationFrame(updateParallax);
  }

  window.requestAnimationFrame(updateParallax);
});
